import React, { Component } from "react";
import styles from "./footer.module.css";
import { _t } from "src/redux/store";
import renderHTML from "html-react-parser";
import { ReactComponent as Over18Icon } from "src/icons/over-18-age-restriction.svg";

class Footer extends Component {
  render() {
    const currentYear = new Date().getFullYear();
    const domainLink = "https://" + (process.env.REACT_APP_DOMAIN as string) || "";
    const domain = (process.env.REACT_APP_DOMAIN as string) || "";
    return (
      <div className={styles.container}>
        <div className={styles.containerCol}>
          <p>
            @{process.env.REACT_APP_TITLE} [2008 - {currentYear}]
          </p>
          <p>{process.env.REACT_APP_SUPPORT_EMAIL}</p>
          <p className={styles.link}>
            {renderHTML(
              _t.translate(
                "Interface page for register on <a href='{{url}}' target='_blank'>{{domain}}</a> betting platform",
                { url: domainLink, domain: domain }
              )
            )}
          </p>
        </div>
        <div className={styles.containerRow}>
          <p className={styles.text}>
            {renderHTML(
              _t.translate(
                "{{domain}} LICENSE_INFO",
                { domain: domain.toUpperCase() }
              )
            )}
          </p>
          <div className={styles.imgContainer}>
            <Over18Icon />
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;
